export const CATALOG_PAGE_TYPES = <Readonly<['PRODUCT', 'CATEGORY', 'DYNAMIC_CATEGORY']>>[
  'PRODUCT',
  'CATEGORY',
  'DYNAMIC_CATEGORY',
]

export const CLOTHING_CATEGORY_UID = 'MjQ='
